import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map, Observable, switchMap } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [AsyncPipe, TranslateModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly translate = inject(TranslateService);

  // `translate.stream` (rather than `translate.instant`) re-emits once the
  // translation file finishes loading and on every later language change,
  // so the heading never renders as a raw, untranslated key such as
  // "errorPage.unauthorized" while `assets/i18n/en.json` is still loading.
  readonly title$: Observable<string> = this.route.queryParams.pipe(
    map((params) => this.messageKey(params)),
    switchMap((key) => this.translate.stream(key))
  );

  private messageKey(params: Params): string {
    const error = params['error'];
    const errorDescription = params['error_description'];

    if (error === 'unauthorized' && errorDescription === 'user is blocked') {
      return 'errorPage.blocked';
    }

    if (error === 'access_denied') {
      return 'errorPage.accessDenied';
    }

    return 'errorPage.unauthorized';
  }

  logOut(): void {
    this.authenticationService.logout();
  }
}
